import React, { Component } from 'react'
import { Link } from "react-router-dom";
import {  Menu, Icon, Header, Dropdown } from 'semantic-ui-react'
import { version } from '../../package.json'
import GoogleAnalytics from 'react-ga'

class TopMenu extends Component {
  
  reload()
  {
    window.location.reload(true)
    GoogleAnalytics.event({category: 'Main', action: 'Reload' });
  }
  
  render() {
    return (
      <div><Header>korAccount Mobile</Header>
      <Menu fixed="bottom" fluid size="large" icon="labeled">
        <Menu.Item as={Link} to="/"><Icon name="list"></Icon>Liste</Menu.Item>
        <Menu.Item as={Link} to="/add" title="Neuer Eintrag"><Icon name="add"></Icon>Hinzufügen</Menu.Item>
        <Menu.Item as={Link} to="/sync"><Icon name="download" title="In korAccount übertragen"></Icon>Übertragen</Menu.Item>
        <Menu.Item as={Link} to="/about" title="Fragen und Antworten"><Icon name="question circle"></Icon>FAQ</Menu.Item>
        <Menu.Item onClick={this.reload} title="Seite aktualisieren"><Icon name='sync' />Neu laden</Menu.Item>
        {/* <Menu.Item><Input placeholder="Search..." icon="search"></Input></Menu.Item> */}
      </Menu>
        </div>      
    )
  }
}

class TopMenuDesktop extends Component {
  reload(){
    window.location.reload(true)
    GoogleAnalytics.event({category: 'Main', action: 'Reload' });
  }
  render() {
    return (
      <Menu fixed="top" fluid>
        <Menu.Item as={Link} to="/desktop" header>korAccount Mobile v{ version }</Menu.Item>
        <Menu.Menu position="right">
        <Menu.Item onClick={this.reload} title="Seite aktualisieren"><Icon name='sync' /></Menu.Item>
        </Menu.Menu>
      </Menu>
      
    )
  }
}

export  {TopMenu,TopMenuDesktop}